import {Base} from "@/api/Base"

export class PunchTheClockByEmp extends Base {
    path = "attendance/punchTheClockByEmp"
}